import { EMPTY_RULE } from '../Interfaces.helpers';
import {
  DICOM_CONNECTION_FIELDS,
  FIELD_TYPES,
  INSTITUTIONS_FIELD,
  normalizeInstitutions,
} from '../Interfaces.shared';

export const DICOM_INTERFACE_TYPES = {
  sending: {
    id: 'sending',
    titleKey: 'Settings.dicom_sending_nodes',
    dialogTitleKey: 'Settings.dicom_sending_node_config',
    dialogSubtitleKey: 'Settings.dicom_node_config_subtitle',
    endpoint: 'dicom_node_send',
    emptyNode: {
      name: '',
      ip: '',
      aet: '',
      port: '',
      institutions: [],
      sending_rules: [EMPTY_RULE],
    },
    fields: [...DICOM_CONNECTION_FIELDS, INSTITUTIONS_FIELD],
    customFields: ['sending_rules'],
    displayFields: ['name', 'aet', 'ip', 'port', 'institutions'],
    detailsRenderer: 'dicomSending',
    testEndpoint: (name) => `pacs_echo/${name}`,
    testMethod: 'GET',
    hasTest: true,
    normalize: (s) => ({
      name: s.Name || s.name,
      ip: s.IP || s.ip,
      aet: s.AET || s.aet,
      port: s.Port || s.port,
      institutions: normalizeInstitutions(s.institutions),
      sending_rules: Array.isArray(s.sending_rules) ? s.sending_rules : [],
    }),
  },
  querying: {
    id: 'querying',
    titleKey: 'Settings.dicom_querying_nodes',
    dialogTitleKey: 'Settings.dicom_querying_node_config',
    dialogSubtitleKey: 'Settings.dicom_node_config_subtitle',
    endpoint: 'dicom_node_query',
    emptyNode: {
      name: '',
      ip: '',
      aet: '',
      port: '',
    },
    fields: DICOM_CONNECTION_FIELDS,
    displayFields: ['name', 'aet', 'ip', 'port'],
    testEndpoint: (name) => `pacs_echo/${name}`,
    testMethod: 'GET',
    hasTest: true,
    normalize: (s) => ({
      name: s.Name || s.name,
      ip: s.IP || s.ip,
      aet: s.AET || s.aet,
      port: s.Port || s.port,
    }),
  },
};

export const DICOM_COLLECTIONS = [
  {
    id: 'sending',
    titleKey: 'Settings.dicom_sending_nodes',
    typeIds: ['sending'],
    defaultTypeId: 'sending',
    emptyMessageKey: 'Settings.no_sending_servers_found',
  },
  {
    id: 'querying',
    titleKey: 'Settings.dicom_querying_nodes',
    typeIds: ['querying'],
    defaultTypeId: 'querying',
    emptyMessageKey: 'Settings.no_querying_servers_found',
  },
];

export { FIELD_TYPES };
